import React, { useEffect, useState } from 'react';
import Joyride, { STATUS, EVENTS } from 'react-joyride';

const PatientListTour = ({ isLoading, hasPatients, forceStart, onTourEnd }) => {
  const [run, setRun] = useState(false);
  const [steps, setSteps] = useState([]);

  useEffect(() => {
    if (forceStart) {
      setRun(false); 
    }

    const seenGeneralList = localStorage.getItem('tour_seen_list');
    const seenChatButton = localStorage.getItem('tour_seen_chat_button');

    if ((isLoading || !hasPatients || seenGeneralList) && !forceStart) return;

    const initialSteps = [
      { target: '.tour-list-filters', content: 'Narrow down your patient list here. Filter by availability, date of birth, tags, groups, status, location, or care team—and combine filters to quickly find the exact patient you’re looking for.', placement: 'bottom', disableBeacon: true },
      { target: '.tour-list-searchname', content: 'Looking for a specific patient? Type their name here to instantly filter the list.', placement: 'bottom', disableBeacon: true },
      { target: '.tour-list-apply', content: 'Click here to apply your selected filters and update the patient list.', placement: 'bottom', disableBeacon: true },
      { target: '.tour-list-reset', content: 'Reset all filters and return to the full patient list.', placement: 'bottom', disableBeacon: true },
      { target: '.tour-list-relationship', content: 'This shows how the patient is related to the account holder (for example: self, parent, or dependent).', placement: 'bottom', disableBeacon: true },
      { target: '.tour-list-view', content: 'Click here to view full patient details, including medical and profile information.', placement: 'bottom', disableBeacon: true },
      { target: '.tour-list-status', content: 'This indicates whether the patient is active or inactive. Inactive patients are no longer currently engaged but remain in your records.', placement: 'bottom', disableBeacon: true },
      { target: '.tour-list-pagination', content: 'Use these controls to navigate through multiple pages of patients. Move forward or backward to see more results.', placement: 'top', disableBeacon: true },
    ];

    let allSteps = [...initialSteps];

    setTimeout(() => {
      if ((forceStart || !seenChatButton) && document.querySelector('.tour-chat-button')) {
        allSteps.push({
          target: '.tour-chat-button',
          content: 'Click here to start a conversation with this patient. If the icon is not visible, chat may not be available for that patient.',
          placement: 'bottom',
          disableBeacon: true,
        });
      }

      setSteps(allSteps);
      setRun(allSteps.length > 0);
    }, 500); 
  }, [isLoading, hasPatients, forceStart]);

  const handleJoyrideCallback = (data) => {
    const { status, type, index } = data;

    if (type === EVENTS.STEP_BEFORE) {
      if ([1, 2, 3].includes(index)) {
        const searchInput = document.querySelector('.tour-list-searchname');
        if (!searchInput || searchInput.offsetParent === null) {
          const accordionHeaderButton = document.querySelector('.tour-list-filters button');
          if (accordionHeaderButton) {
            accordionHeaderButton.click();
          }
        }
      }
    }

    const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];
    if (finishedStatuses.includes(status)) {
      setRun(false);
      if (onTourEnd) onTourEnd();
      localStorage.setItem('tour_seen_list', 'true');
      localStorage.setItem('tour_seen_chat_button', 'true');
    }
  };

  return (
    <Joyride
      steps={steps}
      run={run}
      continuous={true}
      showProgress={true}
      showSkipButton={true}
      scrollToFirstStep={true}
      hideCloseButton={true}
      scrollOffset={250} 
      
      callback={handleJoyrideCallback}
      styles={{
        options: { primaryColor: '#000000', textColor: '#000000', zIndex: 9999 },
        tooltip: { borderRadius: '8px', padding: '20px' },
        buttonNext: { backgroundColor: '#3c8138', borderRadius: '4px' },
        buttonBack: { color: '#3c8138' }
      }}
    />
  );
};

export default PatientListTour;